import { useTranslate } from "@refinedev/core";
import { IconButton, Modal } from "@libertify/ui";
import styled from "styled-components";
import { LessonLabel } from "./LessonLabel";
import { Flex, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { XIcon } from "@phosphor-icons/react";

type TutorialVideoModalProps = Readonly<{
  lessonNumber: number | null;
  title: string | null;
  embedUrl: string | null;
  onClose: () => void;
}>;

export const TutorialVideoModal = ({
  lessonNumber,
  title,
  embedUrl,
  onClose,
}: TutorialVideoModalProps) => {
  const t = useTranslate();
  const { theme } = useAntTheme();

  const titleComponent = () => {
    return (
      <Flex align="start" justify="space-between">
        <Flex gap={12} align="center">
          {lessonNumber !== null ? (
            <LessonLabel lessonNumber={lessonNumber} />
          ) : undefined}
          <Typography.Text
            strong
            style={{ color: theme.colorBgBase, fontSize: 16 }}
          >
            {title}
          </Typography.Text>
        </Flex>
        <IconButton
          icon={<XIcon />}
          size="s"
          shape="round"
          variant="secondary"
          onClick={onClose}
        />
      </Flex>
    );
  };

  return (
    <Modal
      open={!!embedUrl}
      onClose={onClose}
      closable={false}
      size="xlarge"
      showFooter={false}
      destroyOnHidden
      styles={{
        body: { padding: 0, background: "transparent" },
        header: { padding: 0, paddingBottom: 14, background: "transparent" },
        content: { background: "transparent", boxShadow: "none" },
        mask: {
          background: "rgba(9, 14, 25, 0.78)",
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
        },
      }}
      title={titleComponent()}
    >
      {embedUrl && title ? (
        <StyledPlayerFrame
          src={embedUrl}
          title={t("pages.tutorials.videoPlayerTitle", { title })}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ) : null}
    </Modal>
  );
};

// ─── Styled components ───

const StyledPlayerFrame = styled.iframe`
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  border: none;
`;
